import React from "react";
import {
  Stack, Typography, Avatar, TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmptyImage from "../../Assets/empty-box.png"
//Srcs
import "./emptydata.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
export default function EmptyData({ colSpan }) {

    // Change Language
    const { language } = React.useContext(AuthContext);
    const { t } = translateLauguage(language);

  // return (
  // <Stack direction="row" justifyContent="center" className="empty-container">
  //   <Stack direction="column" justifyContent="center" height="300px" spacing={1}>
  //     <Stack direction="row" justifyContent="center">
  //       <img src={EmptyImage} alt="icon" className="empty-image"/>
  //     </Stack>
  //     <Typography className="text-title">No data</Typography>
  //   </Stack>
  // </Stack>
  // );
  // console.log("colSpan==>", colSpan)
  return (
    <>
      {colSpan ?
        <TableBody className="body">
          <TableRow className="body-row">
            <TableCell colSpan={colSpan} className="body-cell">
              <Stack direction="row" justifyContent="center" className="empty-container">
                <Stack direction="column" justifyContent="center" height="300px" spacing={1}>
                  <Stack direction="row" justifyContent="center">
                    <img src={EmptyImage} alt="icon" className="empty-image" />
                  </Stack>
                  <Typography className={language === "en" ? "text-title" : "text-title-kh"}>{t("no_data")}</Typography>
                </Stack>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
        : (<Stack direction="row" justifyContent="center" className="empty-container">
          <Stack direction="column" justifyContent="center" height="300px" spacing={1}>
            <Stack direction="row" justifyContent="center">
              <img src={EmptyImage} alt="icon" className="empty-image" />
            </Stack>
            <Typography className={language === "en" ? "text-title" : "text-title-kh"}>{t("no_data")}</Typography>
          </Stack>
        </Stack>)
      }
    </>
  )
}
